var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"col-12 col-sm-8 pa-16",attrs:{"justify":"center","align":"center"}},[_c('book-list-icon',{attrs:{"size":72}}),_c('h1',[_vm._v(_vm._s(_vm.$t('shop.noBooksFound')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }